<template>
    <SectionContentLayout
      :state="message_state"
      :container_class="hidden ? 'hidden' : null"
      content_class="messages-open"
      invalid_text="messages.open.invalid"
      invalid_icon="fas fa-inbox"
      @contentClick="onContentClick"
      @contentBlur="onContentBlur"
      @errorRetry="onErrorRetry"
      >
        <template #close>
          <ActionButton
              @click="onActionClose()"
              class="close"
              icon="fas fa-times-circle"
              v-tooltip='"global.actions.close"'
          />
        </template>

        <template #actions_success>
            <ActionButton
                @click="onActionUnread()"
                v-tooltip='"messages.actions.mark_unread"'
                icon='fas fa-envelope'
            />
            <ActionButton v-if="route.name !== 'popup-message-open'"
                @click="messages_view.onActionMove(dummy_selection)"
                v-tooltip='"messages.actions.move_message"'
                icon='fas fa-folder-open'
            />
            <ActionButton
                @click="onActionDelete()"
                v-tooltip='"messages.actions.move_trash"'
                icon='fas fa-trash-alt'
                :loading="trash_message"
            />
            <ActionButton v-if="folder_id !== 'U3BhbQ'"
                @click="onActionSpam()"
                v-tooltip='"messages.actions.mark_spam"'
                icon='fas fa-shield-alt'
            />
            <ActionButton v-if="folder_id === 'U3BhbQ'"
                @click="onActionNotSpam()"
                v-tooltip='"messages.actions.mark_not_spam"'
                icon='fas fa-ban'
            />

            <DropdownList class="more-actions align-right">
                <template #select>
                    <ActionButton
                        v-tooltip='"messages.actions.more"'
                        icon='fas fa-ellipsis-v'
                    />
                </template>

                <template #options>
                    <ActionButton
                        @click="onActionShowSource()"
                        icon='fas fa-code'
                        text='messages.actions.source_code'
                    />
                    <ActionButton v-show="message.flags.flagged === false"
                        @click="props.viewport_controller.flagFlagged(folder_id, [message.id])"
                        icon='fas fa-bookmark'
                        text="messages.actions.mark_flagged"
                        class="clear"
                    />
                    <ActionButton v-show="message.flags.flagged === true"
                        @click="props.viewport_controller.flagUnflagged(folder_id, [message.id])"
                        icon='far fa-bookmark'
                        text="messages.actions.mark_unflagged"
                        class="clear"
                    />

                    <ActionButton
                        @click="messages_view.onActionBlacklist(dummy_selection)"
                        icon='fas fa-lock'
                        text="messages.actions.blacklist_email"
                        class="clear"
                    />

                    <ActionButton
                        @click="messages_view.onActionWhitelist(dummy_selection)"
                        icon='fas fa-lock-open'
                        text="messages.actions.whitelist_email"
                        class="clear"
                    />

                    <ActionButton v-if="route.name !== 'popup-message-open'"
                        @click="messages_view.onActionAddFilter(dummy_selection)"
                        icon='fas fa-filter'
                        text='messages.actions.add_filter'
                    />
                    <LinkButton
                        :link="message.download"
                        icon='fas fa-save'
                        text='messages.actions.download'
                    />
                    <ActionButton
                        @click="onActionPrint()"
                        icon='fas fa-print'
                        text='messages.actions.print'
                    />
                </template>
            </DropdownList>
        </template>

        <template #content_success>
            <MessageMDNReceipt v-if="message.mdn.requested"
              :viewport_controller="viewport_controller"
              :folder_id="folder_id"
              :message="message"
            />

            <MessageFlags v-if="message.flags.priority_high || message.flags.flagged"
              :message="message"
            />

            <MessageSubject
              :message="message"
              :folder_id="folder_id"
              @openMessagePopup="onOpenMessagePopup()"
            />

            <MessageRecipients
              :recipients="message.recipients"
            />

          <MessageTopActions
            :webmail_view="webmail_view"
            :folder_id="folder_id"
            :message="message"
          />

          <MessageAttachments v-if='message.attachments.count'
              @attachmentClick='onAttachmentClick'
              @attachmentCloudAdd="onAttachmentCloudAdd"
              :attachments='message.attachments'
            />

          <MessageBody
            @attachmentClick='onAttachmentClick'
            :message='message'
          />

          <MessageAttachments v-if='message.attachments.count'
            @attachmentClick='onAttachmentClick'
            :attachments='message.attachments'
            :thumbnails=true
          />

          <MessageBottomActions
            :webmail_view="webmail_view"
            :message="message"
            :folder_id="folder_id"
          />
        </template>
    </SectionContentLayout>

    <MessageSourceModal v-if="message_source_visibility"
       @modalWindowClose="onActionCloseSource()"
       :message="message"
       :folder_id="folder_id"
       :viewport_controller="viewport_controller"
    />

    <MessageAttachmentsGallery v-if="message_attachments_visibility"
        @galleryClose='onAttachmentsGalleryClose()'
        :options='attachments_gallery_options'
        :attachments='message.attachments'
    />

    <ComposeAttachmentsMeoCloud v-if="meo_cloud_visibility"
      @modalWindowClose="onMeoCloudModalClose()"
      :meo_cloud_controller="meo_cloud_controller"
      :meo_cloud_attachment="meo_cloud_attachment"
      type="attachment_upload"
    >
    </ComposeAttachmentsMeoCloud>
</template>

<script setup>
  import {ref, reactive, defineProps}     from 'vue';
  import {onBeforeMount, onBeforeUnmount} from 'vue';
  import {useRoute}                   from 'vue-router';
  import MessageSourceModal           from '../Modals/MessageSourceModal.vue';
  import MessageSubject               from '../Partials/MessageSubject.vue';
  import MessageRecipients            from '../Partials/MessageRecipients.vue';
  import MessageMDNReceipt            from '../Partials/MessageMDNReceipt.vue';
  import MessageFlags                 from '../Partials/MessageFlags.vue';
  import MessageTopActions            from '../Partials/MessageTopActions.vue';
  import MessageAttachments           from '../Partials/MessageAttachments.vue';
  import MessageAttachmentsGallery    from '../Partials/MessageAttachmentsGallery.vue';
  import MessageBody                  from '../Partials/MessageBody.vue';
  import MessageBottomActions         from '../Partials/MessageBottomActions.vue';
  import ComposeAttachmentsMeoCloud   from "@/vue/Views/Compose/Modals/Partials/ComposeAttachmentsMeoCloud.vue";

  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue';
  import DropdownList                 from '@/vue/Elements/DropDowns/DropdownList.vue';
  import LinkButton                   from '@/vue/Elements/Buttons/LinkButton.vue';
  import SectionContentLayout         from '@/vue/Layouts/Sections/SectionContentLayout.vue';
  import MessagesSelectionCollection  from '@/js/Mailboxes/Collections/MessagesSelectionCollection';
  import IdentitiesController         from '@/js/Settings/Identities/IdentitiesController';
  import PopupController              from '@/js/Webmail/PopupController';
  import DomController                from '@/js/Webmail/DomController';
  import { KeyboardProfile }          from '@/js/Webmail/Keyboard/KeyboardMetadata';
  import KeyboardController           from '@/js/Webmail/Keyboard/KeyboardController';
  import LayoutSettingsController     from '@/js/Webmail/LayoutSettingsController';
  import MeoCloudController           from "@/js/Compose/MeoCloudController";
import ViewportController from '@/js/Mailboxes/ViewportController';

  const props = defineProps({
    messages_view      : {},
    webmail_view       : {},
    viewport_controller: {},
    folder_id          : {},
    hidden             : {
      default: false,
    },
  });

  const route                          = useRoute();
  const message_id                     = route.params.message_id;
  const message                        = ref();
  const dummy_selection                = reactive(new MessagesSelectionCollection());
  const meo_cloud_controller           = reactive(new MeoCloudController());
  const message_source_visibility      = ref();
  const message_attachments_visibility = ref();
  const meo_cloud_visibility           = ref(false);
  const meo_cloud_attachment           = ref();
  const message_state                  = ref('loading');
  const trash_message                  = ref(false);
  const attachments_gallery_options    = {
    index   : 0,
    preview : null,
  }

  onBeforeMount(() => {
    props.viewport_controller.state.on(`${props.folder_id}:${message_id}`, 'success', onLoad);
    props.viewport_controller.state.on(`${props.folder_id}:${message_id}`, 'error', onError);
    props.viewport_controller.fetchMessage(props.folder_id, message_id);

    if (LayoutSettingsController.theme_orientation === 'top') {
      KeyboardController.disable(KeyboardProfile.MESSAGES_ITEM_LIST);
    }

    KeyboardController.create(KeyboardProfile.MESSAGE_ITEM_OPEN, {
      close  : onKeyboardClose,
      delete : onKeyboardTrash,
    })
  })

  onBeforeUnmount(() => {
    props.viewport_controller.state.destroy(`${props.folder_id}:${message_id}`, 'success', onLoad);
    props.viewport_controller.state.destroy(`${props.folder_id}:${message_id}`, 'error', onError);

    if (props.viewport_controller.state.events[`${props.folder_id}:${message_id}`] === 'success') {
      message.value.attachments.deleteAttachmentsContents();
    }

    KeyboardController.delete(KeyboardProfile.MESSAGE_ITEM_OPEN);
    KeyboardController.enable(KeyboardProfile.MESSAGES_ITEM_LIST);
  })

  const onLoad = async () => {
    setMessage();
    setMessageState();

    if (message_state.value !== 'success') {
      return;
    }

    setDummySelection();
    props.messages_view.setFolderTitle();
    // props.messages_view.setMessageTitle(message.value.subject);

    props.messages_view.setFolderTitle();
    // props.messages_view.setMessageTitle(message.value.subject);
  }

  const onError = async () => {
    message_state.value = 'error';
  }

  const onErrorRetry = () => {
    props.viewport_controller.fetchMessage(props.folder_id, message_id);
  }

  const onKeyboardClose = () => {
    close();
  }

  const onKeyboardTrash = async () => {
    setTrashMessage(true);
    await props.messages_view.onActionDelete(dummy_selection);
    close();
    setTrashMessage(false);
  }

  const onActionClose = () => {
    if (route.name === 'popup-message-open') {
      closeMessagePopup();
      return;
    }

    close();
  }

  const onOpenMessagePopup = () => {
    openMessagePopup();
  }

  const onActionPrint = () => {
    let url = ViewportController.getMessagePrintURL(message.value, props.folder_id);

    PopupController.openExternal({
      path: url
    })
  }

  const onActionShowSource = () => {
    setMessageSourceVisibility(true);
  }

  const onActionDelete = async () => {
    setTrashMessage(true);
    await props.messages_view.onActionDelete(dummy_selection);
    closeMessagePopup();
    setTrashMessage(false);
  }

  const onActionSpam = () => {
    props.messages_view.onActionSpam(dummy_selection);
    closeMessagePopup();
  }

  const onActionNotSpam = () => {
    props.messages_view.onActionNotSpam(dummy_selection);
    closeMessagePopup();
  }

  const onActionUnread = () => {
    props.messages_view.onActionUnread(dummy_selection);
    props.webmail_view.routeTo('/messages/' + props.folder_id);
    closeMessagePopup();
  }

  const onActionCloseSource = () => {
    setMessageSourceVisibility(false);
  }

  const onAttachmentClick = (index, preview) => {
    setMessageAttachmentsVisibility(true);
    setAttachmentGalleryOptions(index, preview);
    DomController.setBodyFullScreen();
  }

  const onMeoCloudModalClose = () => {
    setMeocloudVisibility(false);
  }

  const onAttachmentCloudAdd = (attachment) => {
    setMeocloudVisibility(true);
    setMeoCloudAttachment(attachment);
  }

  const onAttachmentsGalleryClose = () => {
    setMessageAttachmentsVisibility(false);
    DomController.unsetBodyFullScreen();
  }

  const onContentClick = () => {
    KeyboardController.disable(KeyboardProfile.MESSAGES_ITEM_LIST);
  }

  const onContentBlur = () => {
    KeyboardController.enable(KeyboardProfile.MESSAGES_ITEM_LIST);
  }

  const setMessage = () => {
    message.value = props.viewport_controller.mailboxes.viewport.get(props.folder_id).get(message_id);
  }

  const setDummySelection = () => {
    dummy_selection.add(message.value);
  }

  const setMessageState = () => {
    message_state.value = message.value.invalid || !message.value.id ? 'invalid' : props.viewport_controller.state.events[`${props.folder_id}:${message_id}`];
  }

  const setMessageSourceVisibility = (value) => {
    message_source_visibility.value = value;
  }

  const setMessageAttachmentsVisibility = (value) => {
    message_attachments_visibility.value = value;
  }

  const setAttachmentGalleryOptions = (index, preview) => {
    attachments_gallery_options.index   = index;
    attachments_gallery_options.preview = preview;
  }

  const setMeocloudVisibility = (value) => {
    meo_cloud_visibility.value = value;
  }

  const setMeoCloudAttachment = (attachment) => {
    meo_cloud_attachment.value = attachment;
  }

  const setTrashMessage = (value) => {
    trash_message.value = value;
  }

  const openMessagePopup = () => {
    PopupController.open({
      path: '/messages/' + props.folder_id + '/' + message.value.id,
      data: {
        messages_view      : props.messages_view,
        popup_view         : props.webmail_view,
        viewport_controller: props.viewport_controller,
        folder_id          : props.folder_id,
      }
    })
  }

  const closeMessagePopup = () => {
    PopupController.closeCurrentPopup();
  }

  const close = () => {
    props.webmail_view.routeTo('/messages/' + props.folder_id);
  }

</script>
